import { createContext, useContext } from "react";
import { TranslationsProviderHookProps } from "./TranslationsProvider.types.js";

export const TranslationsContext = createContext<TranslationsProviderHookProps>({
    translations: {},
});

export const useTranslationsContext = () => useContext(TranslationsContext);
